import { ExtendedCustomer, ExtendedReservation } from '../types/salonboard';
import { TreatmentRecordInput, PhysicalCondition } from '../types/treatment';
import { Service } from '../types/service';

// デモ顧客データ
export const DEMO_CUSTOMERS: ExtendedCustomer[] = [
  {
    id: 1001,
    name: '山田 花子',
    nameKana: 'ヤマダ ハナコ',
    phone: '090-1234-5678',
    email: 'hanako@example.com',
    birthday: '1985-05-15',

    address: '東京都渋谷区恵比寿1-2-3',
    occupation: 'ITエンジニア',
    totalVisits: 5,
    lastVisit: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3日前
    totalSpent: 45000,
    customFields: {
      other1: 'デモデータ：定期的に来店される常連のお客様',
      other2: '',
      other3: ''
    },
    tags: ['VIP', 'リピーター'],
    rank: 'gold' as const,
    status: 'active' as const,
    customerCode: 'CUS-1001',
    preferredStaff: '田中',
    createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(), // 90日前
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  {
    id: 1002,
    name: '佐藤 太郎',
    nameKana: 'サトウ タロウ',
    phone: '080-9876-5432',
    email: 'taro@example.com',
    birthday: '1990-03-20',

    address: '東京都新宿区西新宿2-3-4',
    occupation: '会社員',
    totalVisits: 2,
    lastVisit: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // 1週間前
    totalSpent: 15400,
    customFields: {
      other1: 'デモデータ：最近通い始めたお客様',
      other2: '',
      other3: ''
    },
    tags: ['新規'],
    rank: 'bronze' as const,
    status: 'active' as const,
    customerCode: 'CUS-1002',
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30日前
    updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  }
];
// 顧客インサイト機能用の追加顧客データ
export const INSIGHT_DEMO_CUSTOMERS: ExtendedCustomer[] = [
  {
    id: 1,
    name: '山田 花子',
    nameKana: 'ヤマダ ハナコ',
    phone: '090-1111-2222',
    email: 'yamada.hanako@example.com',
    birthday: '1988-03-15',
    address: '東京都渋谷区神宮前3-4-5',
    occupation: 'デザイナー',
    totalVisits: 30,
    lastVisit: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 320000,
    customFields: {
      other1: '標準的な優良顧客パターン',
      other2: '規則的に通うリピーター',
      other3: ''
    },
    tags: ['常連', 'リピーター'],
    rank: 'gold' as const,
    status: 'active' as const,
    customerCode: 'CUS-0001',
    preferredStaff: '田中',
    createdAt: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  {
    id: 2,
    name: '鈴木 太郎',
    nameKana: 'スズキ タロウ',
    phone: '090-3333-4444',
    email: 'suzuki.taro@example.com',
    birthday: '1975-08-20',
    address: '東京都港区六本木5-6-7',
    occupation: '経営者',
    totalVisits: 50,
    lastVisit: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 850000,
    customFields: {
      other1: 'VIPプラチナ顧客パターン',
      other2: '高頻度・高単価利用',
      other3: '特別対応要'
    },
    tags: ['VIP', 'プラチナ', '最重要顧客'],
    rank: 'platinum' as const,
    status: 'active' as const,
    customerCode: 'CUS-0002',
    preferredStaff: '山田',
    createdAt: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  {
    id: 3,
    name: '佐藤 美咲',
    nameKana: 'サトウ ミサキ',
    phone: '090-5555-6666',
    email: 'sato.misaki@example.com',
    birthday: '1992-11-10',
    address: '東京都世田谷区三軒茶屋2-3-4',
    occupation: '看護師',
    totalVisits: 25,
    lastVisit: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 220000,
    customFields: {
      other1: '離脱リスク高パターン',
      other2: '3ヶ月来店なし',
      other3: '要フォローアップ'
    },
    tags: ['離脱リスク', '要注意', 'フォロー必要'],
    rank: 'silver' as const,
    status: 'inactive' as const,
    customerCode: 'CUS-0003',
    preferredStaff: '佐藤',
    createdAt: new Date(Date.now() - 300 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: false
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  {
    id: 99,
    name: '開発 テスト',
    nameKana: 'カイハツ テスト',
    phone: '090-9999-9999',
    email: 'dev.test@example.com',
    birthday: '1990-01-01',
    address: '東京都千代田区丸の内1-1-1',
    occupation: 'エンジニア',
    totalVisits: 100,
    lastVisit: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 1200000,
    customFields: {
      other1: '開発・テスト用データ',
      other2: '全パターン網羅',
      other3: '季節変動データあり'
    },
    tags: ['開発用', 'テスト', '全パターン'],
    rank: 'platinum' as const,
    status: 'active' as const,
    customerCode: 'CUS-0099',
    preferredStaff: '田中',
    createdAt: new Date(Date.now() - 730 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  }
];

// 山田花子さんの施術履歴
export const DEMO_TREATMENTS_YAMADA: TreatmentRecordInput[] = [
  {
    date: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), // 2週間前
    customerId: 1001,
    staffId: 1,
    staffName: '田中',
    treatmentMenu: 'ドライヘッドスパ60分コース',
    treatmentDuration: 60,
    physicalCondition: '疲れ気味',
    symptoms: ['頭痛', '肩こり', '眼精疲労'],
    painLevel: 7,
    stressLevel: 8,
    sleepQuality: 4,
    techniques: ['頭皮マッサージ', '側頭筋リリース', '後頭部指圧'],
    focusAreas: ['後頭部', '側頭筋', '首筋'],
    pressure: 6,
    notes: {
      before: 'デスクワークで首肩がガチガチ。週3回の頭痛',
      during: '後頭部と側頭筋を重点的にケア。特に右側の緊張が強い',
      after: '施術後、頭がスッキリしたとのこと。肩の可動域も改善',
      conversation: '最近仕事が忙しく、睡眠時間が4-5時間。カフェイン摂取も多い'
    },
    improvements: ['頭の軽さ', '肩の可動域改善'],
    feedback: '頭がスッキリして視界が明るくなった',
    treatmentAmount: 6600,
    productAmount: 0,
    paymentMethod: 'cash',
    status: 'completed',
    customerName: '山田 花子',
    requests: '',
    concerns: '',
    lifestyle: {},
    isFirstVisit: false
  },
  {
    date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), // 1週間前
    customerId: 1001,
    staffId: 2,
    staffName: '佐藤',
    treatmentMenu: 'ドライヘッドスパ90分コース',
    treatmentDuration: 90,
    physicalCondition: '疲れ気味',
    symptoms: ['不眠', 'ストレス', '頭重感'],
    painLevel: 5,
    stressLevel: 9,
    sleepQuality: 3,
    techniques: ['自律神経調整', '深層筋アプローチ', 'リラクゼーション'],
    focusAreas: ['頭頂部', '前頭部', '首の付け根'],
    pressure: 4,
    notes: {
      before: '前回から頭痛の頻度は減少。睡眠の質を改善したい',
      during: '自律神経調整を意識した施術。呼吸が深くなってきた',
      after: 'リラックスして少し眠ってしまった。体が軽くなった',
      conversation: '仕事のプレッシャーが続いている。リラックス方法を探している'
    },
    improvements: ['頭痛頻度減少', '肩の可動域向上', '呼吸が深くなった'],
    feedback: '施術中に深くリラックスできた。久しぶりによく眠れそう',
    treatmentAmount: 8800,
    productAmount: 0,
    paymentMethod: 'credit',
    status: 'completed',
    customerName: '山田 花子',
    requests: '',
    concerns: '',
    lifestyle: {},
    isFirstVisit: false
  },
  {
    date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), // 3日前
    customerId: 1001,
    staffId: 3,
    staffName: '鈴木',
    treatmentMenu: 'ヘッドスパ＋フェイシャル120分',
    treatmentDuration: 120,
    physicalCondition: '普通',
    symptoms: ['顔のむくみ', '頭皮の硬さ'],
    stressLevel: 5,
    sleepQuality: 6,
    techniques: ['リンパドレナージュ', 'フェイシャルマッサージ', '頭皮ケア'],
    focusAreas: ['頭皮全体', 'フェイスライン', 'デコルテ'],
    pressure: 5,
    lifestyle: {
      workStyle: 'リモートワーク中心',
      exerciseFrequency: '週2-3回ヨガ'
    },
    notes: {
      before: 'イベント前なので顔もスッキリさせたい',
      during: '頭皮から顔にかけてリンパドレナージュ実施',
      after: 'フェイスラインがシャープに。目元もパッチリ',
      conversation: '来週の結婚式に向けて準備中。ストレスもあるが楽しみ'
    },
    improvements: ['フェイスラインすっきり', '目元パッチリ', '頭皮の柔軟性向上'],
    feedback: '顔色が明るくなって嬉しい！写真映りが良くなりそう',
    nextRecommendation: '2週間後に再度施術を推奨',
    treatmentAmount: 13200,
    productAmount: 3300,
    products: [
      {
        id: 1,
        name: 'スカルプエッセンス',
        price: 3300,
        quantity: 1
      }
    ],
    paymentMethod: 'credit',
    status: 'completed',
    customerName: '山田 花子',
    requests: '',
    concerns: '',
    isFirstVisit: false
  }
];

// 佐藤太郎さんの施術履歴
export const DEMO_TREATMENTS_SATO: TreatmentRecordInput[] = [
  {
    date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), // 1週間前
    customerId: 1002,
    staffId: 1,
    staffName: '田中',
    treatmentMenu: 'ドライヘッドスパ60分コース',
    treatmentDuration: 60,
    physicalCondition: '普通',
    symptoms: ['頭痛', '肩こり'],
    painLevel: 6,
    stressLevel: 7,
    sleepQuality: 5,
    techniques: ['頭皮マッサージ', '首肩リリース'],
    focusAreas: ['後頭部', '首', '肩'],
    pressure: 7,
    notes: {
      before: '初回来店。デスクワークによる肩こりがひどい',
      during: '全体的に緊張が強い。特に首から肩にかけて',
      after: '肩が軽くなったとのこと',
      conversation: '友人の紹介で来店。定期的に通いたい'
    },
    improvements: ['肩の軽さ', '頭痛軽減'],
    feedback: '思っていた以上に気持ちよかった。また来たい',
    treatmentAmount: 6600,
    productAmount: 0,
    paymentMethod: 'cash',
    status: 'completed',
    customerName: '佐藤 太郎',
    requests: '',
    concerns: '',
    lifestyle: {},
    isFirstVisit: true
  },
  {
    date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000), // 1日前
    customerId: 1002,
    staffId: 1,
    staffName: '田中',
    treatmentMenu: 'ドライヘッドスパ90分コース',
    treatmentDuration: 90,
    physicalCondition: '疲れ気味',
    symptoms: ['頭痛', '肩こり', '眼精疲労'],
    painLevel: 7,
    stressLevel: 8,
    sleepQuality: 4,
    techniques: ['頭皮マッサージ', '側頭筋リリース', '肩甲骨はがし'],
    focusAreas: ['側頭筋', '後頭部', '肩甲骨周り'],
    pressure: 6,
    notes: {
      before: '前回から1週間。肩こりは少し改善したが頭痛が続く',
      during: '側頭筋の緊張が強い。念入りにケア',
      after: '頭痛が軽減。視界がクリアになった',
      conversation: 'プロジェクトの締め切りが近く、ストレスが溜まっている'
    },
    improvements: ['頭痛軽減', '視界改善', '肩の可動域向上'],
    feedback: '前回より長いコースにして正解だった。しっかりほぐれた',
    nextRecommendation: '2週間後にメンテナンス推奨',
    treatmentAmount: 8800,
    productAmount: 0,
    paymentMethod: 'credit',
    status: 'completed',
    customerName: '佐藤 太郎',
    requests: '',
    concerns: '',
    lifestyle: {},
    isFirstVisit: false
  }
];
// 山田花子（ID:1）の施術記録 - 標準的な優良顧客パターン
export const INSIGHT_TREATMENTS_YAMADA_HANAKO: TreatmentRecordInput[] = (() => {
  const records: TreatmentRecordInput[] = [];
  const menus = [
    { name: 'ドライヘッドスパ60分コース', duration: 60, price: 8800 },
    { name: 'ドライヘッドスパ90分コース', duration: 90, price: 13200 },
    { name: 'アロマヘッドスパ60分', duration: 60, price: 9900 }
  ];
  const staffNames = ['田中', '山田', '佐藤'];
  
  // 過去12ヶ月、月2-3回の施術記録を生成
  for (let month = 11; month >= 0; month--) {
    const visitsThisMonth = month === 0 ? 2 : (month % 2 === 0 ? 3 : 2);
    
    for (let visit = 0; visit < visitsThisMonth; visit++) {
      const daysAgo = month * 30 + visit * 10 + Math.floor(Math.random() * 5);
      const menu = menus[Math.floor(Math.random() * menus.length)];
      const staffName = staffNames[Math.floor(Math.random() * staffNames.length)];
      
      records.push({
        date: new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000),
        customerId: 1,
        staffId: staffNames.indexOf(staffName) + 1,
        staffName: staffName,
        treatmentMenu: menu.name,
        treatmentDuration: menu.duration,
        physicalCondition: '普通',
        symptoms: ['肩こり', '頭重感', '眼精疲労'].slice(0, Math.floor(Math.random() * 3) + 1),
        painLevel: 4 + Math.floor(Math.random() * 3),
        stressLevel: 5 + Math.floor(Math.random() * 3),
        sleepQuality: 5 + Math.floor(Math.random() * 3),
        techniques: ['頭皮マッサージ', '側頭筋リリース', '後頭部指圧'].slice(0, Math.floor(Math.random() * 3) + 1),
        focusAreas: ['後頭部', '側頭筋', '首筋'].slice(0, Math.floor(Math.random() * 3) + 1),
        pressure: 5 + Math.floor(Math.random() * 2),
        notes: {
          before: 'デスクワークによる疲労感',
          during: '重点的にケアを実施',
          after: 'スッキリした様子',
          conversation: '仕事の話題が中心'
        },
        improvements: ['頭の軽さ', '肩の可動域改善'],
        feedback: '今回も満足です',
        treatmentAmount: menu.price,
        productAmount: visit === 0 && month % 3 === 0 ? 3300 : 0,
        paymentMethod: Math.random() > 0.5 ? 'credit' : 'cash',
        status: 'completed',
        customerName: '山田 花子',
        requests: '',
        concerns: '',
        lifestyle: {
          workStyle: 'デスクワーク中心',
          exerciseFrequency: '週1-2回ヨガ'
        },
        isFirstVisit: false
      });
    }
  }
  
  return records;
})();

// 鈴木太郎（ID:2）の施術記録 - VIPプラチナ顧客パターン
export const INSIGHT_TREATMENTS_SUZUKI: TreatmentRecordInput[] = (() => {
  const records: TreatmentRecordInput[] = [];
  const premiumMenus = [
    { name: 'ドライヘッドスパ90分コース', duration: 90, price: 13200 },
    { name: 'ヘッドスパ＋フェイシャル120分', duration: 120, price: 18000 },
    { name: 'プレミアムヘッドスパ120分', duration: 120, price: 22000 }
  ];
  const staffNames = ['山田', '田中'];
  
  // 過去12ヶ月、月4-5回の施術記録を生成
  for (let month = 11; month >= 0; month--) {
    const visitsThisMonth = month % 3 === 0 ? 5 : 4;
    
    for (let visit = 0; visit < visitsThisMonth; visit++) {
      const daysAgo = month * 30 + visit * 6 + Math.floor(Math.random() * 3);
      const menu = premiumMenus[Math.floor(Math.random() * premiumMenus.length)];
      const staffName = staffNames[Math.floor(Math.random() * staffNames.length)];
      
      records.push({
        date: new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000),
        customerId: 2,
        staffId: staffNames.indexOf(staffName) + 1,
        staffName: staffName,
        treatmentMenu: menu.name,
        treatmentDuration: menu.duration,
        physicalCondition: '疲れ気味',
        symptoms: ['ストレス', '不眠', '頭痛', '疲労'].slice(0, Math.floor(Math.random() * 3) + 2),
        painLevel: 6 + Math.floor(Math.random() * 3),
        stressLevel: 7 + Math.floor(Math.random() * 3),
        sleepQuality: 3 + Math.floor(Math.random() * 3),
        techniques: ['深層筋アプローチ', '自律神経調整', 'リンパドレナージュ', '頭皮ケア'],
        focusAreas: ['頭皮全体', '首の付け根', 'デコルテ'],
        pressure: 6 + Math.floor(Math.random() * 2),
        notes: {
          before: '経営ストレスによる緊張',
          during: 'じっくりと時間をかけて施術',
          after: 'リラックスした表情',
          conversation: 'ビジネスの相談も'
        },
        improvements: ['深いリラックス', '頭痛軽減', '睡眠改善'],
        feedback: 'いつも最高のサービスをありがとう',
        treatmentAmount: menu.price,
        productAmount: visit === 0 && month % 2 === 0 ? 5500 : 0,
        products: visit === 0 && month % 2 === 0 ? [
          { id: 1, name: 'プレミアムヘッドエッセンス', price: 5500, quantity: 1 }
        ] : undefined,
        paymentMethod: 'credit',
        status: 'completed',
        customerName: '鈴木 太郎',
        requests: 'しっかりとほぐしてほしい',
        concerns: '経営ストレス',
        lifestyle: {
          workStyle: '経営者・多忙',
          exerciseFrequency: '月2-3回ゴルフ'
        },
        isFirstVisit: false
      });
    }
  }
  
  return records;
})();

// 佐藤美咲（ID:3）の施術記録 - 離脱リスク高パターン
export const INSIGHT_TREATMENTS_SATO_MISAKI: TreatmentRecordInput[] = (() => {
  const records: TreatmentRecordInput[] = [];
  const menus = [
    { name: 'ドライヘッドスパ60分コース', duration: 60, price: 8800 },
    { name: 'ドライヘッドスパ90分コース', duration: 90, price: 13200 }
  ];
  const staffNames = ['佐藤', '田中', '山田'];
  
  // 9ヶ月前まで月3回、その後来店なし
  for (let month = 11; month >= 3; month--) {
    const visitsThisMonth = 3;
    
    for (let visit = 0; visit < visitsThisMonth; visit++) {
      const daysAgo = month * 30 + visit * 8 + Math.floor(Math.random() * 4);
      const menu = menus[Math.floor(Math.random() * menus.length)];
      const staffName = staffNames[Math.floor(Math.random() * staffNames.length)];
      
      records.push({
        date: new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000),
        customerId: 3,
        staffId: staffNames.indexOf(staffName) + 1,
        staffName: staffName,
        treatmentMenu: menu.name,
        treatmentDuration: menu.duration,
        physicalCondition: '疲れ気味',
        symptoms: ['肩こり', '腰痛', '不規則な生活'],
        painLevel: 7,
        stressLevel: 8,
        sleepQuality: 4,
        techniques: ['頭皮マッサージ', '肩周りケア'],
        focusAreas: ['肩', '首', '頭皮'],
        pressure: 6,
        notes: {
          before: '夜勤明けで疲労困憊',
          during: '疲れが溜まっている様子',
          after: '少し楽になった',
          conversation: '仕事が忙しくて大変そう'
        },
        improvements: ['肩の軽さ', '頭痛緩和'],
        feedback: '助かりました',
        treatmentAmount: menu.price,
        productAmount: 0,
        paymentMethod: 'cash',
        status: 'completed',
        customerName: '佐藤 美咲',
        requests: '',
        concerns: '不規則勤務による体調不良',
        lifestyle: {
          workStyle: '看護師・夜勤あり',
          exerciseFrequency: 'ほとんどなし'
        },
        isFirstVisit: false
      });
    }
  }
  
  // 最後の来店（3ヶ月前）
  records.push({
    date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    customerId: 3,
    staffId: 1,
    staffName: '佐藤',
    treatmentMenu: 'ドライヘッドスパ60分コース',
    treatmentDuration: 60,
    physicalCondition: '不調',
    symptoms: ['極度の疲労', '頭痛', '不眠'],
    painLevel: 9,
    stressLevel: 10,
    sleepQuality: 2,
    techniques: ['頭皮マッサージ', '自律神経調整'],
    focusAreas: ['頭皮全体', '首'],
    pressure: 4,
    notes: {
      before: '転職を検討中で精神的にも疲れている',
      during: 'かなり疲労が蓄積している',
      after: '少し眠ってしまった',
      conversation: '引っ越しを考えているとのこと'
    },
    improvements: ['一時的なリラックス'],
    feedback: 'また来たいけど時間が...',
    treatmentAmount: 8800,
    productAmount: 0,
    paymentMethod: 'cash',
    status: 'completed',
    customerName: '佐藤 美咲',
    requests: '',
    concerns: '生活環境の変化',
    lifestyle: {
      workStyle: '転職検討中',
      exerciseFrequency: 'なし'
    },
    isFirstVisit: false
  });
  
  return records;
})();

// 開発用（ID:99）の施術記録 - 全パターン網羅
export const INSIGHT_TREATMENTS_DEV: TreatmentRecordInput[] = (() => {
  const records: TreatmentRecordInput[] = [];
  const allMenus = [
    { name: 'ドライヘッドスパ30分', duration: 30, price: 4400 },
    { name: 'ドライヘッドスパ60分コース', duration: 60, price: 8800 },
    { name: 'ドライヘッドスパ90分コース', duration: 90, price: 13200 },
    { name: 'アロマヘッドスパ60分', duration: 60, price: 9900 },
    { name: 'アロマヘッドスパ90分', duration: 90, price: 14300 },
    { name: 'ヘッドスパ＋フェイシャル120分', duration: 120, price: 18000 },
    { name: 'プレミアムヘッドスパ120分', duration: 120, price: 22000 },
    { name: 'クイックヘッドスパ15分', duration: 15, price: 2200 }
  ];
  const staffNames = ['田中', '山田', '佐藤', '鈴木'];
  
  // 過去24ヶ月の豊富なデータ（季節変動付き）
  for (let month = 23; month >= 0; month--) {
    // 季節変動: 夏は少なめ、冬は多め
    const seasonFactor = Math.sin((month + 3) * Math.PI / 6) * 0.5 + 1;
    const baseVisits = 4;
    const visitsThisMonth = Math.round(baseVisits * seasonFactor);
    
    for (let visit = 0; visit < visitsThisMonth; visit++) {
      const daysAgo = month * 30 + visit * Math.floor(30 / visitsThisMonth) + Math.floor(Math.random() * 5);
      const menu = allMenus[Math.floor(Math.random() * allMenus.length)];
      const staffName = staffNames[Math.floor(Math.random() * staffNames.length)];
      
      // 様々なパターンのデータを生成
      const stressLevel = Math.floor(Math.random() * 10) + 1;
      const sleepQuality = Math.floor(Math.random() * 10) + 1;
      const painLevel = Math.floor(Math.random() * 10) + 1;
      
      records.push({
        date: new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000),
        customerId: 99,
        staffId: staffNames.indexOf(staffName) + 1,
        staffName: staffName,
        treatmentMenu: menu.name,
        treatmentDuration: menu.duration,
        physicalCondition: ['良好', '普通', '疲れ気味', '不調'][Math.floor(Math.random() * 4)] as PhysicalCondition,
        symptoms: ['頭痛', '肩こり', '眼精疲労', '不眠', 'ストレス', '腰痛', 'めまい']
          .sort(() => Math.random() - 0.5)
          .slice(0, Math.floor(Math.random() * 4) + 1),
        painLevel: painLevel,
        stressLevel: stressLevel,
        sleepQuality: sleepQuality,
        techniques: ['頭皮マッサージ', '側頭筋リリース', '後頭部指圧', '自律神経調整', 'リンパドレナージュ']
          .sort(() => Math.random() - 0.5)
          .slice(0, Math.floor(Math.random() * 3) + 2),
        focusAreas: ['頭頂部', '側頭部', '後頭部', '首', '肩', 'デコルテ']
          .sort(() => Math.random() - 0.5)
          .slice(0, Math.floor(Math.random() * 3) + 1),
        pressure: Math.floor(Math.random() * 10) + 1,
        notes: {
          before: `テストデータ: month=${month}, visit=${visit}`,
          during: '様々な施術パターンをテスト',
          after: 'データ生成確認',
          conversation: `季節要因: ${seasonFactor.toFixed(2)}`
        },
        improvements: ['改善項目1', '改善項目2', '改善項目3']
          .slice(0, Math.floor(Math.random() * 3) + 1),
        feedback: ['とても満足', '満足', '普通', '素晴らしい'][Math.floor(Math.random() * 4)],
        treatmentAmount: menu.price,
        productAmount: Math.random() > 0.8 ? Math.floor(Math.random() * 5 + 1) * 1100 : 0,
        paymentMethod: ['cash', 'credit', 'paypay'][Math.floor(Math.random() * 3)] as any,
        status: 'completed',
        customerName: '開発 テスト',
        requests: Math.random() > 0.7 ? 'テストリクエスト' : '',
        concerns: Math.random() > 0.7 ? 'テスト相談内容' : '',
        lifestyle: {
          workStyle: ['リモートワーク', 'オフィスワーク', 'ハイブリッド'][Math.floor(Math.random() * 3)],
          exerciseFrequency: ['毎日', '週3-4回', '週1-2回', 'なし'][Math.floor(Math.random() * 4)],
          stressFactors: Math.random() > 0.5 ? ['仕事', 'プライベート'] : undefined
        },
        isFirstVisit: false,
        nextRecommendation: Math.random() > 0.5 ? '2週間後の来店を推奨' : undefined,
        followUpRequired: Math.random() > 0.8
      });
    }
  }
  
  return records.sort((a, b) => b.date.getTime() - a.date.getTime());
})();

// ========================================
// ========================================

export const DEMO_RESERVATIONS = (() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const reservations = [];

  // スタッフ情報
  const staffData = [
    { id: 'staff1', name: '佐藤', color: '#6c5ce7' },
    { id: 'staff2', name: '田中', color: '#fd79a8' },
    { id: 'staff3', name: '山田', color: '#00b894' }
  ];

  // サービス情報
  const services = [
    { id: '1', name: 'ドライヘッドスパ60分', duration: 60, price: 8500 },
    { id: '2', name: 'アロマヘッドスパ45分', duration: 45, price: 6500 },
    { id: '3', name: 'プレミアムヘッドスパ90分', duration: 90, price: 12000 },
    { id: '4', name: 'ベーシックヘッドスパ30分', duration: 30, price: 4500 },
  ];

  // 顧客情報（既存のDEMO_CUSTOMERSを使用）
  const customers = [
    { id: 1001, name: '山田 花子', phone: '090-1234-5678', email: 'hanako@example.com', tier: 'gold' as const, isVip: true },
    { id: 1002, name: '佐藤 太郎', phone: '080-9876-5432', email: 'taro@example.com', tier: 'regular' as const, isVip: false },
    { id: 1, name: '山田 花子', phone: '090-1111-2222', email: 'yamada.hanako@example.com', tier: 'gold' as const, isVip: true },
    { id: 2, name: '鈴木 太郎', phone: '080-2222-3333', email: 'suzuki.taro@example.com', tier: 'platinum' as const, isVip: true },
  ];

  let reservationId = 1;

  // ヘルパー関数: 時刻文字列から終了時刻を計算
  const calculateEndTime = (startTime: string, duration: number): string => {
    const [hours, minutes] = startTime.split(':').map(Number);
    const startMinutes = hours * 60 + minutes;
    const endMinutes = startMinutes + duration;
    const endHours = Math.floor(endMinutes / 60);
    const endMins = endMinutes % 60;
    return `${String(endHours).padStart(2, '0')}:${String(endMins).padStart(2, '0')}`;
  };

  // ====================================
  // 過去2日間の完了済み予約 (3-5件/日)
  // ====================================
  for (let daysAgo = 2; daysAgo >= 1; daysAgo--) {
    const date = new Date(today);
    date.setDate(date.getDate() - daysAgo);
    const count = Math.floor(Math.random() * 3) + 3; // 3-5件

    for (let i = 0; i < count; i++) {
      const customer = customers[Math.floor(Math.random() * customers.length)];
      const staff = staffData[Math.floor(Math.random() * staffData.length)];
      const service = services[Math.floor(Math.random() * services.length)];
      const hour = 9 + Math.floor(Math.random() * 9); // 9:00-17:00
      const startTime = `${String(hour).padStart(2, '0')}:00`;
      const endTime = calculateEndTime(startTime, service.duration);

      reservations.push({
        id: String(reservationId++),
        customerId: customer.id,
        customerName: customer.name,
        customerPhone: customer.phone,
        customerEmail: customer.email,
        staffId: staff.id,
        staffName: staff.name,
        serviceId: service.id,
        serviceName: service.name,
        date: date,
        startTime: startTime,
        endTime: endTime,
        duration: service.duration,
        status: 'completed',
        notes: '施術完了',
        color: staff.color,
        createdAt: new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000),
        updatedAt: date,
        isVip: customer.isVip,
        price: service.price,
        customerTier: customer.tier
      });
    }
  }

  // ====================================
  // 今日の予約 (6件、混合ステータス)
  // ====================================
  const todayReservations = [
    // 9:00 - 確定
    {
      customer: customers[0],
      staff: staffData[0],
      service: services[0],
      startTime: '09:00',
      status: 'confirmed' as const,
      notes: 'いつもありがとうございます'
    },
    // 10:30 - 確定
    {
      customer: customers[3],
      staff: staffData[1],
      service: services[2],
      startTime: '10:30',
      status: 'confirmed' as const,
      notes: 'プラチナ会員様、VIP対応'
    },
    // 12:00 - 保留
    {
      customer: customers[1],
      staff: staffData[0],
      service: services[1],
      startTime: '12:00',
      status: 'pending' as const,
      notes: '確認待ち'
    },
    // 14:00 - 確定
    {
      customer: customers[2],
      staff: staffData[2],
      service: services[0],
      startTime: '14:00',
      status: 'confirmed' as const,
      notes: ''
    },
    // 15:30 - キャンセル
    {
      customer: customers[1],
      staff: staffData[1],
      service: services[3],
      startTime: '15:30',
      status: 'cancelled' as const,
      notes: 'お客様都合によりキャンセル'
    },
    // 17:00 - 確定
    {
      customer: customers[0],
      staff: staffData[2],
      service: services[1],
      startTime: '17:00',
      status: 'confirmed' as const,
      notes: '仕事帰りに来店予定'
    }
  ];

  todayReservations.forEach(res => {
    const endTime = calculateEndTime(res.startTime, res.service.duration);
    reservations.push({
      id: String(reservationId++),
      customerId: res.customer.id,
      customerName: res.customer.name,
      customerPhone: res.customer.phone,
      customerEmail: res.customer.email,
      staffId: res.staff.id,
      staffName: res.staff.name,
      serviceId: res.service.id,
      serviceName: res.service.name,
      date: today,
      startTime: res.startTime,
      endTime: endTime,
      duration: res.service.duration,
      status: res.status,
      notes: res.notes,
      color: res.staff.color,
      createdAt: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000),
      updatedAt: today,
      isVip: res.customer.isVip,
      price: res.service.price,
      customerTier: res.customer.tier
    });
  });

  // ====================================
  // 未来5日間の予約 (4-6件/日)
  // ====================================
  for (let daysAhead = 1; daysAhead <= 5; daysAhead++) {
    const date = new Date(today);
    date.setDate(date.getDate() + daysAhead);
    const count = Math.floor(Math.random() * 3) + 4; // 4-6件

    for (let i = 0; i < count; i++) {
      const customer = customers[Math.floor(Math.random() * customers.length)];
      const staff = staffData[Math.floor(Math.random() * staffData.length)];
      const service = services[Math.floor(Math.random() * services.length)];
      const hour = 9 + Math.floor(Math.random() * 9); // 9:00-17:00
      const startTime = `${String(hour).padStart(2, '0')}:00`;
      const endTime = calculateEndTime(startTime, service.duration);

      // 80% confirmed, 20% pending
      const status = Math.random() < 0.8 ? 'confirmed' : 'pending';

      reservations.push({
        id: String(reservationId++),
        customerId: customer.id,
        customerName: customer.name,
        customerPhone: customer.phone,
        customerEmail: customer.email,
        staffId: staff.id,
        staffName: staff.name,
        serviceId: service.id,
        serviceName: service.name,
        date: date,
        startTime: startTime,
        endTime: endTime,
        duration: service.duration,
        status: status,
        notes: status === 'pending' ? '予約確認中' : '',
        color: staff.color,
        createdAt: new Date(date.getTime() - 3 * 24 * 60 * 60 * 1000),
        updatedAt: new Date(),
        isVip: customer.isVip,
        price: service.price,
        customerTier: customer.tier
      });
    }
  }

  return reservations.sort((a, b) => a.date.getTime() - b.date.getTime());
})() as ExtendedReservation[];
// 全機能確認用デモデータセット (新規追加)

// 新規6名の追加顧客データ
export const DEMO_CUSTOMERS_EXTENDED: ExtendedCustomer[] = [
  // 1003: 新規顧客（初回来店、お試しメニュー）
  {
    id: 1003,
    name: '田中 健一',
    nameKana: 'タナカ ケンイチ',
    phone: '080-1111-3333',
    email: 'kenichi.tanaka@example.com',
    birthday: '1987-09-10',
    address: '東京都品川区大崎3-4-5',
    occupation: '営業職',
    totalVisits: 1,
    lastVisit: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 4400,
    customFields: {
      other1: '新規顧客：友人の紹介で初回来店',
      other2: '',
      other3: ''
    },
    tags: ['新規', '紹介'],
    rank: 'bronze' as const,
    status: 'active' as const,
    customerCode: 'CUS-1003',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  // 1004: 固定顧客（毎月第1土曜日に来店）
  {
    id: 1004,
    name: '高橋 由美',
    nameKana: 'タカハシ ユミ',
    phone: '090-2222-4444',
    email: 'yumi.takahashi@example.com',
    birthday: '1980-12-25',
    address: '東京都目黒区自由が丘1-2-3',
    occupation: '主婦',
    totalVisits: 24,
    lastVisit: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 211200,
    customFields: {
      other1: '固定客：毎月第1土曜日13:00予約',
      other2: 'ドライヘッドスパ60分コース固定',
      other3: ''
    },
    tags: ['固定客', 'VIP', '定期'],
    rank: 'gold' as const,
    status: 'active' as const,
    customerCode: 'CUS-1004',
    preferredStaff: '山田',
    createdAt: new Date(Date.now() - 730 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  // 1005: リターン顧客（6ヶ月離脱→復帰）
  {
    id: 1005,
    name: '伊藤 大輔',
    nameKana: 'イトウ ダイスケ',
    phone: '080-3333-5555',
    email: 'daisuke.ito@example.com',
    birthday: '1993-06-15',
    address: '東京都中央区銀座4-5-6',
    occupation: '金融',
    totalVisits: 8,
    lastVisit: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 70400,
    customFields: {
      other1: 'リターン顧客：6ヶ月離脱後に復帰',
      other2: '転勤から戻ってきた',
      other3: ''
    },
    tags: ['リターン', '復活'],
    rank: 'silver' as const,
    status: 'active' as const,
    customerCode: 'CUS-1005',
    createdAt: new Date(Date.now() - 400 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  // 1006: グループ利用（友人と一緒に予約）
  {
    id: 1006,
    name: '渡辺 愛',
    nameKana: 'ワタナベ アイ',
    phone: '090-4444-6666',
    email: 'ai.watanabe@example.com',
    birthday: '1995-03-08',
    address: '東京都杉並区荻窪2-3-4',
    occupation: 'アパレル',
    totalVisits: 6,
    lastVisit: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 52800,
    customFields: {
      other1: 'グループ利用：いつも友人2-3名と一緒',
      other2: '同時予約希望',
      other3: ''
    },
    tags: ['グループ', '友人'],
    rank: 'silver' as const,
    status: 'active' as const,
    customerCode: 'CUS-1006',
    createdAt: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: true,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  // 1007: キャンセル常習（キャンセル率高）
  {
    id: 1007,
    name: '中村 翔',
    nameKana: 'ナカムラ ショウ',
    phone: '080-5555-7777',
    email: 'sho.nakamura@example.com',
    birthday: '1991-11-20',
    address: '東京都豊島区池袋1-2-3',
    occupation: 'フリーランス',
    totalVisits: 4,
    lastVisit: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 35200,
    customFields: {
      other1: 'キャンセル常習：10回予約中6回キャンセル',
      other2: '直前キャンセルが多い',
      other3: '要注意顧客'
    },
    tags: ['要注意', 'キャンセル多'],
    rank: 'bronze' as const,
    status: 'inactive' as const,
    customerCode: 'CUS-1007',
    createdAt: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: false,
      sms: false
    },
    deliveryHistory: [],
    mergeHistory: {}
  },
  // 1008: 外部予約サイト経由（ホットペッパービューティー）
  {
    id: 1008,
    name: '小林 麻衣',
    nameKana: 'コバヤシ マイ',
    phone: '090-6666-8888',
    email: 'mai.kobayashi@example.com',
    birthday: '1989-07-30',
    address: '神奈川県横浜市西区みなとみらい1-1-1',
    occupation: 'IT企業',
    totalVisits: 3,
    lastVisit: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    totalSpent: 29700,
    customFields: {
      other1: '外部予約経由：ホットペッパービューティーから',
      other2: 'クーポン利用率高',
      other3: ''
    },
    tags: ['外部予約', 'ホットペッパー', 'クーポン'],
    rank: 'bronze' as const,
    status: 'active' as const,
    customerCode: 'CUS-1008',
    createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    messageSettings: {
      email: true,
      myPage: false,
      sms: true
    },
    deliveryHistory: [],
    mergeHistory: {}
  }
];

// サービスメニューマスタデータ（12種類）
export const DEMO_SERVICES: Partial<Service>[] = [
  {
    id: 'service-001',
    categoryId: 'cat-head-spa',
    name: 'クイックヘッドスパ15分',
    description: 'お試し・ランチタイムに最適な15分コース',
    duration: 15,
    basePrice: 2200,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 1,
    category: 'ドライヘッドスパ',
    price: 2200,
    type: 'normal' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003', 'staff-004'],
    requiredSkillLevel: 'beginner' as const,
    advanceBookingDays: 30,
    minBookingNotice: 120,
    bufferTime: 10,
    options: [],
    tags: ['クイック', 'お試し', 'ランチタイム'],
    popularity: 65,
    targetGender: 'unisex' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 85,
      revenue: 187000,
      averageRating: 4.2,
      cancellationRate: 0.08,
      noShowRate: 0.02
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-002',
    categoryId: 'cat-head-spa',
    name: 'ドライヘッドスパ30分',
    description: '頭皮の基本ケア・リフレッシュに',
    duration: 30,
    basePrice: 4400,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 2,
    category: 'ドライヘッドスパ',
    price: 4400,
    type: 'normal' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003', 'staff-004'],
    requiredSkillLevel: 'beginner' as const,
    advanceBookingDays: 30,
    minBookingNotice: 120,
    bufferTime: 15,
    options: [],
    tags: ['基本', '人気'],
    popularity: 90,
    targetGender: 'unisex' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 320,
      revenue: 1408000,
      averageRating: 4.5,
      cancellationRate: 0.05,
      noShowRate: 0.01
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-003',
    categoryId: 'cat-head-spa',
    name: 'ドライヘッドスパ60分コース',
    description: '最も人気のスタンダードコース',
    duration: 60,
    basePrice: 8800,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 3,
    category: 'ドライヘッドスパ',
    price: 8800,
    type: 'normal' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003', 'staff-004'],
    requiredSkillLevel: 'intermediate' as const,
    advanceBookingDays: 30,
    minBookingNotice: 180,
    bufferTime: 15,
    options: [],
    tags: ['スタンダード', '人気No.1'],
    popularity: 100,
    targetGender: 'unisex' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 580,
      revenue: 5104000,
      averageRating: 4.8,
      cancellationRate: 0.03,
      noShowRate: 0.01
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-004',
    categoryId: 'cat-head-spa',
    name: 'ドライヘッドスパ90分コース',
    description: 'じっくり深いリラクゼーション',
    duration: 90,
    basePrice: 13200,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 4,
    category: 'ドライヘッドスパ',
    price: 13200,
    type: 'normal' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003'],
    requiredSkillLevel: 'advanced' as const,
    advanceBookingDays: 30,
    minBookingNotice: 240,
    bufferTime: 20,
    options: [],
    tags: ['じっくり', 'プレミアム'],
    popularity: 75,
    targetGender: 'unisex' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 240,
      revenue: 3168000,
      averageRating: 4.9,
      cancellationRate: 0.02,
      noShowRate: 0.005
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-005',
    categoryId: 'cat-aroma',
    name: 'アロマヘッドスパ60分',
    description: '香りで癒される贅沢な時間',
    duration: 60,
    basePrice: 9900,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 5,
    category: 'アロマヘッドスパ',
    price: 9900,
    type: 'normal' as const,
    availableStaff: ['staff-002', 'staff-003'],
    requiredSkillLevel: 'intermediate' as const,
    advanceBookingDays: 30,
    minBookingNotice: 180,
    bufferTime: 15,
    options: [],
    tags: ['アロマ', '癒し', '香り'],
    popularity: 80,
    targetGender: 'female' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 160,
      revenue: 1584000,
      averageRating: 4.7,
      cancellationRate: 0.04,
      noShowRate: 0.01
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-006',
    categoryId: 'cat-aroma',
    name: 'アロマヘッドスパ90分',
    description: 'アロマの香りでより深いリラックス',
    duration: 90,
    basePrice: 14300,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 6,
    category: 'アロマヘッドスパ',
    price: 14300,
    type: 'normal' as const,
    availableStaff: ['staff-002', 'staff-003'],
    requiredSkillLevel: 'advanced' as const,
    advanceBookingDays: 30,
    minBookingNotice: 240,
    bufferTime: 20,
    options: [],
    tags: ['アロマ', 'プレミアム'],
    popularity: 65,
    targetGender: 'female' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 95,
      revenue: 1358500,
      averageRating: 4.8,
      cancellationRate: 0.03,
      noShowRate: 0.01
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-007',
    categoryId: 'cat-combination',
    name: 'ヘッドスパ＋フェイシャル120分',
    description: '頭と顔の贅沢ケア',
    duration: 120,
    basePrice: 18000,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 7,
    category: 'コンビネーション',
    price: 18000,
    type: 'normal' as const,
    availableStaff: ['staff-001', 'staff-003'],
    requiredSkillLevel: 'expert' as const,
    advanceBookingDays: 30,
    minBookingNotice: 360,
    bufferTime: 30,
    options: [],
    tags: ['コンビネーション', '贅沢', 'フェイシャル'],
    popularity: 70,
    targetGender: 'female' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 75,
      revenue: 1350000,
      averageRating: 4.9,
      cancellationRate: 0.02,
      noShowRate: 0.005
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-008',
    categoryId: 'cat-premium',
    name: 'プレミアムヘッドスパ120分',
    description: '最上級のリラクゼーション体験',
    duration: 120,
    basePrice: 22000,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 8,
    category: 'プレミアム',
    price: 22000,
    type: 'normal' as const,
    availableStaff: ['staff-001'],
    requiredSkillLevel: 'expert' as const,
    advanceBookingDays: 30,
    minBookingNotice: 480,
    bufferTime: 30,
    options: [],
    tags: ['プレミアム', 'VIP', '最上級'],
    popularity: 55,
    targetGender: 'unisex' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 35,
      revenue: 770000,
      averageRating: 5.0,
      cancellationRate: 0.01,
      noShowRate: 0
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  // クーポンメニュー
  {
    id: 'service-101',
    categoryId: 'cat-coupon',
    name: '【初回限定】ドライヘッドスパ60分',
    description: '初めてのお客様限定の特別価格',
    duration: 60,
    basePrice: 5500,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 101,
    category: 'クーポン',
    price: 5500,
    type: 'coupon' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003', 'staff-004'],
    requiredSkillLevel: 'intermediate' as const,
    advanceBookingDays: 30,
    minBookingNotice: 180,
    bufferTime: 15,
    options: [],
    tags: ['初回限定', 'クーポン', 'お得'],
    popularity: 95,
    targetGender: 'unisex' as const,
    couponType: '初回限定',
    validFrom: '2024-01-01',
    validUntil: '2025-12-31',
    usageLimit: 1,
    targetCustomers: '新規顧客のみ',
    requiredResources: [],
    statistics: {
      totalBookings: 125,
      revenue: 687500,
      averageRating: 4.6,
      cancellationRate: 0.08,
      noShowRate: 0.03
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-102',
    categoryId: 'cat-coupon',
    name: '【平日限定】ドライヘッドスパ90分',
    description: '平日14時までのお得なプラン',
    duration: 90,
    basePrice: 9900,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 102,
    category: 'クーポン',
    price: 9900,
    type: 'coupon' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003'],
    requiredSkillLevel: 'advanced' as const,
    advanceBookingDays: 30,
    minBookingNotice: 240,
    bufferTime: 20,
    options: [],
    tags: ['平日限定', 'クーポン', 'お得'],
    popularity: 70,
    targetGender: 'unisex' as const,
    couponType: '平日限定',
    validFrom: '2024-01-01',
    validUntil: '2025-12-31',
    conditions: '平日14時までの予約限定',
    requiredResources: [],
    statistics: {
      totalBookings: 68,
      revenue: 673200,
      averageRating: 4.7,
      cancellationRate: 0.05,
      noShowRate: 0.02
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-103',
    categoryId: 'cat-coupon',
    name: '【期間限定】アロマヘッドスパ60分',
    description: '季節限定の特別アロマブレンド',
    duration: 60,
    basePrice: 7700,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 103,
    category: 'クーポン',
    price: 7700,
    type: 'coupon' as const,
    availableStaff: ['staff-002', 'staff-003'],
    requiredSkillLevel: 'intermediate' as const,
    advanceBookingDays: 30,
    minBookingNotice: 180,
    bufferTime: 15,
    options: [],
    tags: ['期間限定', 'アロマ', 'クーポン'],
    popularity: 60,
    targetGender: 'female' as const,
    couponType: '期間限定',
    validFrom: '2024-10-01',
    validUntil: '2024-12-31',
    seasonality: 'autumn' as const,
    requiredResources: [],
    statistics: {
      totalBookings: 42,
      revenue: 323400,
      averageRating: 4.8,
      cancellationRate: 0.04,
      noShowRate: 0.01
    },
    createdAt: new Date('2024-10-01'),
    updatedAt: new Date()
  },
  {
    id: 'service-104',
    categoryId: 'cat-coupon',
    name: '【グループ割】ペアヘッドスパ60分×2名',
    description: '2名同時予約で特別価格',
    duration: 60,
    basePrice: 15000,
    taxRate: 0.1,
    isActive: true,
    displayOrder: 104,
    category: 'クーポン',
    price: 15000,
    type: 'coupon' as const,
    availableStaff: ['staff-001', 'staff-002', 'staff-003', 'staff-004'],
    requiredSkillLevel: 'intermediate' as const,
    advanceBookingDays: 30,
    minBookingNotice: 360,
    bufferTime: 15,
    options: [],
    tags: ['グループ', 'ペア', 'クーポン'],
    popularity: 55,
    targetGender: 'unisex' as const,
    couponType: 'グループ割',
    validFrom: '2024-01-01',
    validUntil: '2025-12-31',
    conditions: '2名同時予約必須',
    requiredResources: [],
    statistics: {
      totalBookings: 38,
      revenue: 570000,
      averageRating: 4.5,
      cancellationRate: 0.06,
      noShowRate: 0.02
    },
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date()
  }
];

// 予約データ（30件：過去20件 + 未来10件）
